/**
 * Stops tellen — één definitie voor dashboard, routes-overzicht en routedetail.
 *
 * De routes-API levert álle stops van een route, ook geannuleerde (pariteit
 * met Apex, die filtert niet; zie route-field-reads.ts). Een geannuleerde stop
 * rijdt de chauffeur niet, dus die telt niet mee in "x van y". Tot 02-09 telde
 * het dashboard en het routes-overzicht de API-`totalStops` (mét geannuleerd)
 * en de routedetail de gefilterde lijst: 22/25 naast 22/22 op dezelfde route.
 */

interface StopMetStatus {
  Status__c?: string | null;
}

export function telRouteStops(stops: ReadonlyArray<StopMetStatus> | null | undefined): { total: number; completed: number } {
  if (!stops) return { total: 0, completed: 0 };
  let total = 0;
  let completed = 0;
  for (const s of stops) {
    if (s.Status__c === 'Geannuleerd') continue;
    total += 1;
    if (s.Status__c === 'Verwerkt') completed += 1;
  }
  return { total, completed };
}

/**
 * Route uit de API met de tellers herrekend uit de eigen stoplijst. Zonder
 * stoplijst blijven de API-tellers staan.
 */
export function metGetelde<T extends { stops?: ReadonlyArray<StopMetStatus>; totalStops?: number; completedStops?: number }>(route: T): T {
  if (!route.stops) return route;
  const t = telRouteStops(route.stops);
  return { ...route, totalStops: t.total, completedStops: t.completed };
}
